import { RootScopeEvents } from '../../../common/services/root-scope-types';
import { AngularServices, getAngularService } from '../../core/helpers';
export const toggleSidebar = () => () => {
    const globalUi = getAngularService(AngularServices.GlobalUi);
    globalUi.toggleSidebar();
};
export const flipCamera = () => () => {
    const rootScope = getAngularService(AngularServices.RootScope);
    rootScope.$emit(RootScopeEvents.USER_ACTIONS.FLIP_CAMERA);
};
export const toggleChat = () => () => {
    const activeComponents = getAngularService(AngularServices.ActiveComponents);
    activeComponents.chat.toggleChat();
};
export const openChat = (uuid) => () => {
    const activeComponents = getAngularService(AngularServices.ActiveComponents);
    activeComponents.chat.openChatByPersonUuid(uuid);
};
export const muteParticipant = (uuid) => () => {
    const activeComponents = getAngularService(AngularServices.ActiveComponents);
    activeComponents.phone.turnOffParticipantAudioByUuid(uuid);
};
export const hangUpParticipant = (uuid, id) => () => {
    const activeStreamService = getAngularService(AngularServices.ActiveStreamService);
    const communicationControl = getAngularService(AngularServices.CommunicationControl);
    communicationControl.removeByUuid(uuid);
    activeStreamService.onStreamDestroy(id);
};
export const setParticipantView = (view) => (dispatch) => {
    dispatch({ type: 'CALL-MOBILE/SET_PARTICIPANTS_VIEW', payload: view });
};
export const openActionsForParticipantId = (participantId) => (dispatch) => {
    dispatch({ type: 'CALL-MOBILE/TOGGLE_ACTIONS', payload: participantId });
};
export const hideParticipantActions = () => (dispatch) => {
    dispatch({ type: 'CALL-MOBILE/TOGGLE_ACTIONS', payload: null });
};
export const toggleGridView = (isOpen) => (dispatch) => {
    dispatch({ type: 'CALL-MOBILE/TOGGLE_GRID_VIEW', payload: isOpen });
};
